var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHbtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.389 21.847c-1.303 3.987.948 7.763 2.236 9.153-2.237-.78-7.037-3.519-8.339-8.237-1.627-5.899 4.068-10.272 6.915-14.238C15.48 5.353 15.507 2.186 15.236 1c.678.508 2.156 1.75 2.644 2.644A10.817 10.817 0 0 1 19 10.864c-.882 4.7-4.984 6-6.611 10.983z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.27 21.847c-1.79 4.15.407 7.83 1.729 9.153 1.728-2.644 4.473-1.83 5.999-7.322 1.22-4.393-1.459-8.95-2.95-10.678-.848 1.22-2.99 4.698-4.78 8.847z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHbtc);
export default __webpack_public_path__ + "static/media/HBTC.c400cd71717020ecbb8b8f55a08f902a.svg";
export { ForwardRef as ReactComponent };